<ng-template #upgradeTemplate>
  <div role="tooltip" class="!tw-whitespace-normal" id="{{getTooltipId()}}">
    This feature is part of <a class="madero-link" href="#" (click)="showUpgradeModal()">{{ requiredPlan }} Plan</a>.
  </div>
</ng-template>
<streamline-icon
  #popoverDirective="bs-popover"
  [popover]="upgradeTemplate"
  ariaLabel="More information"
  ariaDescribedby="{{getTooltipId()}}"
  placement="right"
  boundariesElement="window"
  container="body"
  containerClass="upgrade-popover"
  triggers="mouseenter:click focus:blur"
  [outsideClick]="true"
  class="rise-blue u_clickable"
  [ngClass]="{ 'upgrade-overlay': overlay }"
  name="circleArrowUp"
  width="16"
  height="16"
  tabindex="0"
  (click)="showUpgradeModal(); $event.stopPropagation()"
  (keydown.enter)="showUpgradeModal(); $event.stopPropagation()"
  (keydown.space)="showUpgradeModal(); $event.stopPropagation()"
/>
